import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userId, setUserId] = useState(localStorage.getItem('userId') || null);
  const [userRole, setUserRole] = useState(localStorage.getItem('userRole') || null);
  const [userName, setUserName] = useState(localStorage.getItem('userName') || null);

  const login = ( id, role, user_name) => {
    setUserId(id);
    setUserRole(role);
    setUserName(user_name);
    localStorage.setItem('userId', id);
    localStorage.setItem('userRole', role);
    localStorage.setItem('userName', user_name);
  };

  const logout = () => {
    setUserId(null);
    setUserRole(null);
    setUserName(null);

    localStorage.removeItem('userId');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userName');
  };

  useEffect(() => {
    setUserId(localStorage.getItem('userId'));
    setUserRole(localStorage.getItem('userRole'));
    setUserName(localStorage.getItem('userName'));
  }, []);

  return (
    <AuthContext.Provider value={{  userId, userRole, userName, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
